import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const CalendarIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M16.5 2V6M7.5 2V6" stroke="currentColor" />
      <path
        d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
        stroke="currentColor"
      />
      <path d="M3 10H21" stroke="currentColor" />
    </SvgIcon>
  )
}
